// Cross-device long-press (~400ms). Returns event handlers to spread
// onto the pressed element. A long press fires exactly once per
// press cycle, not again until the pointer is released.

import { useCallback, useRef } from "react";

const THRESHOLD_MS = 400;

export function useLongPress(onLongPress: () => void) {
  const timer = useRef<number | null>(null);
  const fired = useRef(false);

  const clear = useCallback(() => {
    if (timer.current !== null) {
      window.clearTimeout(timer.current);
      timer.current = null;
    }
  }, []);

  const start = useCallback(() => {
    fired.current = false;
    clear();
    timer.current = window.setTimeout(() => {
      fired.current = true;
      onLongPress();
    }, THRESHOLD_MS);
  }, [clear, onLongPress]);

  return {
    onTouchStart: start,
    onTouchEnd: clear,
    onTouchMove: clear,
    onTouchCancel: clear,
    onMouseDown: start,
    onMouseUp: clear,
    onMouseLeave: clear,
    didLongPress: () => fired.current,
  };
}
